<template>
  <div>
    <div class="outgoing-detail" v-if="resultData != null">
      <div class="card print" id="printed-element">
        <!-- HEADER PERUSAHAAN -->
        <div class="company-header">
          <div class="logo">
            <img src="/assets/images/logo.png" alt="mode_logo" />
          </div>
          <div class="company-info">
            <h4 class="header-title"><b>MODE FASHION GROUP</b></h4>
            <h6 class="header-subtitle">Jl.Laksana No 68 ABC, Medan</h6>
            <h6 class="header-subtitle">Telp. (061) 6643780</h6>
          </div>
        </div>

        <div class="border-header"></div>

        <!-- TITLE -->
        <div class="header-container">
          <h4 class="title"><b>DISTRIBUSI BARANG SISA</b></h4>
        </div>

        <!-- TANGGAL -->
        <div class="info-row">
          <div class="left">
            <p><span>Tanggal Mutasi:</span> {{ mutation_date }}</p>
          </div>
        </div>

        <!-- TABEL -->
        <div class="p-grid">
          <div
            class="p-col-12 p-m-auto page-break"
            v-for="(page, pageIndex) in paginatedData"
            :key="pageIndex"
          >
            <table class="text-center detail-bon">
              <thead>
                <tr style="background-color: grey">
                  <th rowspan="2">No</th>
                  <th rowspan="2">Kode Label</th>
                  <th rowspan="2">Nama</th>
                  <th rowspan="2">Qty</th>
                  <th rowspan="2">HM (Rp)</th>
                  <th rowspan="2">Harga Jual (Rp)</th>
                  <th :colspan="outlets.length">Distribusi</th>
                </tr>
                <tr style="background-color: grey">
                  <th v-for="(outlet, i) in outlets" :key="i">
                    {{ outlet.alias }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, k) in page" :key="k" class="table-data-style">
                  <td>{{ pageIndex * 20 + k + 1 }}</td>
                  <td>{{ item.code }}</td>
                  <td class="text-left">{{ truncateText(item.name, 25) }}</td>
                  <td>{{ item.stock }}</td>
                  <td class="text-right">
                    {{ item.init_price | numberFormat }}
                  </td>
                  <td class="text-right">{{ item.price | numberFormat }}</td>
                  <td
                    v-for="(outlet, j) in outlets"
                    :key="j"
                    class="text-center"
                    style="opacity: 0.3"
                  >
                    {{ outlet.alias }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ModeLogo: undefined,
      outlets: null,
      resultData: [],
      mutation_date: null,
      isDataReady: false
    }
  },

  async mounted() {
    try {
      await this.getOutlet()

      // Get data from localStorage using the key from URL
      const dataKey = this.$route.query.key
      if (dataKey) {
        const storedData = localStorage.getItem(dataKey)
        if (storedData) {
          this.resultData = JSON.parse(storedData)
          // Clean up the stored data after retrieving it
          localStorage.removeItem(dataKey)
        }
      } else {
        // Fallback to Vuex store if no key is available
        this.resultData = this.$store.getters.myArray
      }

      console.log('elviraargh', this.resultData)
      const date = new Date()
      this.mutation_date = date.toISOString().split('T')[0]

      // Wait for data to be ready
      this.isDataReady = true

      // Add event listener for afterprint
      window.addEventListener('afterprint', this.handleAfterPrint)

      // Wait for next tick and then print
      this.$nextTick(() => {
        setTimeout(() => {
          window.print()
        }, 1000) // Increased delay to ensure content is rendered
      })
    } catch (error) {
      console.error('Error in mounted:', error)
    }
  },

  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('afterprint', this.handleAfterPrint)
  },

  filters: {
    numberFormat(value) {
      if (!value) return '0'
      return Number(value.replace(/\D/g, '')).toLocaleString('id-ID')
    }
  },

  computed: {
    paginatedData() {
      const perPage = 20
      const pages = []
      for (let i = 0; i < this.resultData.length; i += perPage) {
        pages.push(this.resultData.slice(i, i + perPage))
      }
      return pages
    }
  },

  methods: {
    handleAfterPrint() {
      // Close the current tab
      window.close()
    },

    async getOutlet() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets`
        )
        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        }
      } catch (error) {
        console.error('Error fetching outlets:', error)
      }
    },

    truncateText(text, length) {
      return text.length > length ? text.substring(0, length) + '...' : text
    },

    formatNumber(value) {
      if (!value) return '0'
      return Number(value).toLocaleString('id-ID')
    }
  }
}
</script>
<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

table thead th {
  border: 1px solid #000;
  padding: 8px 6px;
}

.card {
  display: block;
}

.company-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px; // Reduced margin
}

.logo {
  width: 50px; // Slightly smaller logo
}

.company-info {
  margin-left: 30px; // Reduced margin
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-title {
  font-size: 15px; // Slightly smaller
  line-height: 1.2; // Reduced line height
  font-weight: bold;
  margin-bottom: 2px;
}

.header-subtitle {
  font-size: 13px; // Slightly smaller
  line-height: 1.2; // Reduced line height
  margin-bottom: 1px;
}

.title {
  text-align: center;
  margin-bottom: 15px; // Reduced margin
  font-size: 15px; // Slightly smaller
}

.header-container {
  text-align: center;
  margin-bottom: 15px; // Reduced margin
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 12px; // Reduced margin
}

.left,
.right {
  display: flex;
  flex-direction: column;
}

.left p,
.right p {
  display: flex;
  margin: 2px 0; // Reduced margin
}

.left p span,
.right p span {
  display: inline-block;
  width: 150px;
  text-align: left;
}

.border-header {
  border-top: 2px solid black;
  width: 100%;
  margin: 12px auto; // Reduced margin
  justify-content: center;
}

thead tr:nth-child(1) th,
thead tr:nth-child(2) th {
  text-align: center;
  border: 1px solid black;
  padding: 8px 6px; // Reduced padding
  background-color: #f0f0f0;
  font-size: 12px; // Smaller font for headers
  line-height: 1.2; // Reduced line height
}

.detail-bon tbody tr {
  td {
    padding: 8px 6px;
    border: 1px solid #000;
    font-size: 12px;
    line-height: 1.3;
  }
}

.detail-bon tbody tr:nth-child(odd) {
  background-color: white;
}

.detail-bon tbody tr:nth-child(even) {
  background-color: #f8f8f8;
}

.page-break {
  page-break-after: always;
  margin-bottom: 40px;
}

.page-break:last-child {
  page-break-after: auto;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.outgoing-detail {
  font-family: Arial, sans-serif;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  overflow: hidden;
}

@media print {
  .detail-bon {
    border: 1px solid #000;
    border-collapse: collapse;
  }

  .detail-bon th,
  .detail-bon td {
    border: 1px solid #000;
  }

  .detail-bon th {
    padding: 8px 6px;
  }

  .detail-bon td {
    padding: 8px 6px; // Match the new compact padding
  }

  .print table thead {
    display: table-header-group;
  }

  .print:nth-child(1n) {
    page-break-after: always;
  }

  .detail-bon thead tr {
    background-color: #f0f0f0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .detail-bon tbody tr:nth-child(even) {
    background-color: #f8f8f8 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
</style>
